import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UtilityService} from '../../../core/services/utility.service';

@Component({
	selector: 'app-otp-count-down',
	templateUrl: './otp-count-down.component.html',
	styleUrls: ['./otp-count-down.component.scss']
})
export class OtpCountDownComponent implements OnInit, OnDestroy {
	@Input() message: any;
	@Input() expiryTime: any;
	@Output() emitRetryAction: EventEmitter<any> = new EventEmitter<any>();
	countDown: any;
	@Output() emitFinishSuspension = new EventEmitter<any>();
	@Output() emitCountDownStarted = new EventEmitter<any>();
	@Input() canShowErrorMessage: boolean;
	@Input() canShowErrorRetryButton: boolean;
	@Input() errorMessage: string;
	@Input() errorTimer: any;
	@Input() countdownType: CountdownType;
	readonly CountdownType = CountdownType;
	canShowRetryButton: boolean;
	readonly ZERO_TIME = '00';

	constructor(private utilityService: UtilityService) {
	}

	ngOnInit(): void {
		this.message ? '' : this.message = 'Request Expires In';
		if (!this.countdownType) {
			this.countdownType = CountdownType.CUSTOM;
		}
		const canStartCountDown = this.countdownType === CountdownType.KAMONA && this.errorMessage;
		if (!canStartCountDown){
			this.initializeTimer();
		}
		this.utilityService._countDown$.subscribe((data) => {
			this.countDown = data;
			this.emitCountDownStarted.emit(this.countDown ? true : false);
			this.canShowRetryButton = data?.minutes === 0 && data?.seconds === 0;
			if (this.canShowRetryButton) {
				this.utilityService.resetInterval();
			}
			this.errorMessage = this.canShowRetryButton && !this.errorTimer ? null : this.errorMessage;
			if (this.errorMessage || this.canShowRetryButton) {
				this.emitFinishSuspension.emit(this.canShowRetryButton);
			}

		});
	}

	reformatTimer(value: number) {
		if (value <= 0) {
			return this.ZERO_TIME;
		}
		return value >= 10 ? value : `0${value}`;
	}

	initializeTimer() {
		const date = new Date();
		const defaultCountDown = this.utilityService.getDefaultOtpCountDown();
		const timer = this.expiryTime ? new Date(this.expiryTime)?.getTime() :
			this.addTimeInSecondToDate(date, defaultCountDown).getTime();
		const errorTimer = this.errorTimer ? new Date(this.errorTimer)?.getTime() :
			this.addTimeInSecondToDate(date, defaultCountDown).getTime();
		const dateTime = this.errorMessage ? errorTimer : timer;
		this.canShowRetryButton = false;
		this.utilityService.startCountDown(dateTime);
	}

	addTimeInSecondToDate(date, seconds) {
		const numberOfMilliSeconds = date.getTime();
		const addMilliSeconds = seconds * 1000;
		const newDate = new Date(numberOfMilliSeconds + addMilliSeconds);
		return newDate;
	}


	retry() {
		this.initializeTimer();
		this.emitRetryAction.emit();
	}

	ngOnDestroy(): void {
		this.utilityService.resetInterval();
	}
}

export enum CountdownType {
	KAMONA = 'KAMONA',
	CUSTOM = 'CUSTOM',
	OTP_SUSPENSION = 'OTP_SUSPENSION'
}

